import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const Container = styled(Box)`
  display: flex;
  height: 100%;
  width: 100%;
`;

export const Page = styled(Box)`
  display: flex;
  width: 100%;
  /* max-height: calc(100vh - 60px); */
`;
